const Footer = () => {
    return (
        <>
            <div className=" w-full bg-[#141820]  py-1 lg:px-80 md:px-40  px-20 flex items-center h-16  bottom-0 text-white text-xl ">
                <span className="">Designed and Developed by <a className="text-sky-500" href="https://kumarharsh.netlify.app/">Harsh</a></span>
            </div>
        </>
    )
}

export { Footer }
